import ResultNode from "../ResultNode";
import Separator from "../Separator/Separator";
import { Check } from "@educaplay/core/Icons/Check";
import { Wrong } from "@educaplay/core/Icons/Wrong";
import clsx from "clsx";
import classes from "./resultList.module.scss";

import { CARD_CORRECTIONS } from "../../../utils/consts";
import { Fragment } from "react";

const isCardCorrect = (c) => {
  return (
    c.correction == CARD_CORRECTIONS.ok ||
    c.correction == CARD_CORRECTIONS.locked
  );
};

export default function ResultList(props) {
  const { question, answer, isCorrect, questionNumber } = props;

  return (
    <div
      className={clsx(
        classes.questionBriefing,
        isCorrect ? classes.rightAnswer : classes.wrongAnswer
      )}
    >
      <div className={classes.number}>{questionNumber + "."}</div>
      <div className={classes.leftSide}>
        <div className={classes.questions}>{question.bank?.text}</div>
        {answer ? (
          answer.map((it, idx, arrRead) => (
            <Fragment key={questionNumber + "-" + idx}>
              {/* children prop instead of this fragment */}
              <ResultNode
                cardData={it.data}
                idx={idx + 1}
                isCorrect={isCorrect || isCardCorrect(it)}
              />
              {idx < arrRead.length - 1 && (
                <Separator
                  cardArray={arrRead}
                  idx={idx}
                  questionCorrect={isCorrect}
                />
              )}
            </Fragment>
          ))
        ) : (
          <></> // No answer, out of time
        )}
      </div>

      <div className={classes.rightSide}>
        {isCorrect ? (
          <Check />
        ) : (
          <Wrong />
        )}
      </div>
    </div>
  );
}
